import { WorldManifestSchema, type WorldManifest } from './schema';
import { MANIFEST_URL } from '../lib/const';

/**
 * Fetch + Zod-validate the world manifest.
 *
 * Throws:
 *   - Error on HTTP non-OK
 *   - ZodError on schema validation failure (caller handles)
 */
export async function loadWorldManifest(url: string = MANIFEST_URL): Promise<WorldManifest> {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Manifest fetch failed: ${res.status} ${res.statusText}`);
  }
  const data = await res.json();
  return WorldManifestSchema.parse(data);
}
